import styled from 'styled-components';
import { useMapFilterContext } from '../../../context/MapFilterContext';
import { useEffect, useRef, useState } from 'react';
import { DetailMarkers, getColorByCategory } from '../MapMarkers';
import { useMapContext } from '../../../context/MapContext';
import RealDealList from './RealDealList';
import { useLocation, useNavigate } from 'react-router-dom';

const FullRoadView = () => {
  const {
    roadViewLatLng,
    onFullRoadView,
    setOnFullRoadView,
    fullRoadViewMarker,
  } = useMapFilterContext();
  const { onRealDealList } = useMapContext();

  useEffect(() => {
    if (onFullRoadView) {
      // 🛠 풀로드뷰가 켜질 때 가짜 히스토리 추가
      window.history.pushState({ page: 'FullRoadView' }, '');
    }

    const handleBack = () => {
      // console.log('🔙 뒤로 가기 감지됨! 풀로드뷰 닫기');
      setOnFullRoadView(false);
    };

    window.addEventListener('popstate', handleBack);

    return () => {
      window.removeEventListener('popstate', handleBack);
    };
  }, [onFullRoadView, setOnFullRoadView]);

  useEffect(() => {
    if (
      !roadViewLatLng ||
      roadViewLatLng?.lat === 0 ||
      roadViewLatLng?.lng === 0
    ) {
      return;
    }
    if (window.kakao && window.kakao.maps) {
      const container = document.getElementById('FullRoadView');

      const mapCenter = new window.kakao.maps.LatLng(
        roadViewLatLng?.lat,
        roadViewLatLng?.lng,
      );
      const options = {
        center: mapCenter,
        draggable: false,
        level: 3,
        mapTypeId: window.kakao.maps.MapTypeId.SKYVIEW,
        scrollwheel: false,
      };
      var roadview = new window.kakao.maps.Roadview(container, options); //로드뷰 객체
      var roadviewClient = new window.kakao.maps.RoadviewClient();

      var position = new window.kakao.maps.LatLng(
        roadViewLatLng?.lat,
        roadViewLatLng?.lng,
      );

      roadviewClient.getNearestPanoId(position, 100, function (panoId: any) {
        if (panoId) {
          roadview.setPanoId(panoId, position); // panoId가 있으면 로드뷰 실행

          kakao.maps.event.addListener(roadview, 'init', function () {
            // ✅ 기존 마커가 있으면 제거 (이중 생성 방지)

            const markerImage = new window.kakao.maps.MarkerImage(
              getColorByCategory(
                fullRoadViewMarker.data.category.trim(),
              ).pinMarker,
              new window.kakao.maps.Size(40, 46),
            );

            const markerPosition = new window.kakao.maps.LatLng(
              fullRoadViewMarker.lat,
              fullRoadViewMarker.lng,
            );

            let roadViewMarker = new window.kakao.maps.Marker({
              position: markerPosition,
              map: roadview,
              image: markerImage,
            });

            // ✅ 마커가 중앙에 오도록 설정
            var projection = roadview.getProjection();
            var viewpoint = projection.viewpointFromCoords(
              roadViewMarker.getPosition(),
              roadViewMarker.getAltitude(),
            );
            roadview.setViewpoint(viewpoint);
          });
        } else {
          alert('로드뷰를 불러올 수 없습니다.');
          return;
        }
      });
    }
  }, []);

  return (
    <Wrapper>
      {' '}
      <MapWrapper id="FullRoadView"></MapWrapper>
      <CloseButton
        onClick={() => {
          setOnFullRoadView(false);
        }}
      >
        <img src="/assets/images/icon/close_blackCircle.svg" alt="" />
      </CloseButton>
      {onRealDealList && <RealDealList />}
    </Wrapper>
  );
};

export default FullRoadView;

const CloseButton = styled.div`
  position: absolute;
  top: 40px;
  right: 40px;
  z-index: 9999;
  cursor: pointer;
  padding: 10px;
  font-size: 20px;
  color: white;
`;

const MapWrapper = styled.div`
  width: 100%;
  height: 100%;

  /*로드뷰에서 나치반을 없에는 css*/
  [id^='_box_util_'] {
    display: none !important;
  }
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: purple;
  text-align: center !important;
`;
